import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllVendaProducaoAgricola } from '../service';
import {
  LIST_VENDA_PRODUCAO_AGRICOLA,
  LIST_VENDA_PRODUCAO_AGRICOLA_PENDING,
  LIST_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
  LIST_VENDA_PRODUCAO_AGRICOLA_FAILURE
} from '../actionTypes';

function* sagaListAllVendaProducaoAgricola(action) {
  yield put({ type: LIST_VENDA_PRODUCAO_AGRICOLA_PENDING })

  try {
    const list = yield call(findAllVendaProducaoAgricola)
    
    yield put({ type: LIST_VENDA_PRODUCAO_AGRICOLA_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_VENDA_PRODUCAO_AGRICOLA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllVendaProducaoAgricola() {
  yield takeLatest(LIST_VENDA_PRODUCAO_AGRICOLA, sagaListAllVendaProducaoAgricola)
}